/**
 * @fileoverview GET handler for the "/users/subscription_group/double_opt_in_enabled" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { usersSubscriptionGroupDoubleOptInEnabled } from "./constants";
import type { UsersSubscriptionGroupDoubleOptInEnabledResult } from "./types";

export const getUsersSubscriptionGroupDoubleOptInEnabled = reactQueryFetcherAdapter(
  usersSubscriptionGroupDoubleOptInEnabled,
  (signal: AbortSignal, subscriptionGroupId: string): Promise<UsersSubscriptionGroupDoubleOptInEnabledResult> => {
    return fetch(
      "/users/subscription_group/double_opt_in_enabled",
      "GET",
      { subscription_group_id: subscriptionGroupId },
      { signal }
    );
  }
);
